<template>
  <div class="w100 card-shadow bg-w">
    <div class="w100 flex-box al-c bor-b tab-bar">
      <div class="pl20 pr20 font-16 bor-r cu-p tab-bar-item" :class="{ 'active': tabIndex == 0 }" @click="changeTabIndex(0)">推荐</div>
      <div class="pl20 pr20 font-16 bor-r cu-p tab-bar-item" :class="{ 'active': tabIndex == 1 }" @click="changeTabIndex(1)">学工</div>
      <div class="pl20 pr20 font-16 bor-r cu-p tab-bar-item" :class="{ 'active': tabIndex == 2 }" @click="changeTabIndex(2)">人事</div>
      <div class="pl20 pr20 font-16 bor-r cu-p tab-bar-item" :class="{ 'active': tabIndex == 3 }" @click="changeTabIndex(3)">收藏</div>
    </div>
    <div class="w100 pt20 pb20 pl10 pr10" v-loading="loading">
      <el-row :gutter="20" v-loading="loading">
        <el-col class="mb10" :span="6" v-for="(item, index) in list" :key="index">
          <AppCard :data="item" />
        </el-col>
        <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-show="list.length == 0">暂无可用服务</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import AppCard from "@/components/public/AppCard";

export default {
  name: "HomeServe",
  components: {
    AppCard,
  },
  props: ["tourist-active"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      tabIndex: 0,
      list: [],
    };
  },
  computed: {
    url() {
      switch (this.tabIndex) {
        case 0:
          return "/hallServe/servePermitList";
        case 1:
          return "/hallServe/servePermitList";
        case 2:
          return "/hallServe/servePermitList";
        case 3:
          return "/personal/collection/getAllData";
        default:
          break;
      }
    },
  },
  created() {},
  mounted() {
    this.fetchList();
  },
  destroyed() {},
  methods: {
    fetchList() {
      this.loading = true;
      this.list = [];
      let sift = {};
      sift.pageNum = 1;
      sift.pageSize = 100;
      if (this.tabIndex == 0) {
        sift.recommend = 1;
      } else if (this.tabIndex == 1) {
        sift.serveSubject = 1;
      } else if (this.tabIndex == 2) {
        sift.serveSubject = 2;
      }

      if (this.tabIndex == 3) {
        this.$http
          .get(this.url, { params: sift })
          .then(({ data }) => {
            if (data.resCode == 0) {
              this.list = data.resData.list.map((val) => {
                return {
                  id: val.serveId,
                  serveName: val.serveName,
                  serveType: Number(val.serveType),
                  serveTitle: val.serveTitle,
                  appraise: val.score,
                  favoriteCount: val.count,
                  serveImage: val.processLogoDl,
                  collection: val.serveCollect,
                  interfaceUrl: val.interfaceUrl,
                  linkUrl: val.interfaceUrl,
                  // 新增所属部门列表字段
                  deptName: val.deptNameIds
                    ? val.deptNameIds.map((val) => val.deptName).join("、")
                    : "-",
                };
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$http
          .post(this.url, this.$qs.stringify(sift))
          .then(({ data }) => {
            if (data.resCode == 0) {
              this.list = data.resData.list.map((val) => {
                return {
                  id: val.id,
                  serveName: val.serveName,
                  serveType: Number(val.serveType),
                  serveTitle: this.serveSubjectToString(val.serveSubjectList),
                  appraise: val.commentScore,
                  favoriteCount: val.storeCount,
                  serveImage: val.logo,
                  collection: val.serveCollect,
                  interfaceUrl: val.interfaceUrl,
                  linkUrl: val.linkUrl,
                  // 新增所属部门列表字段
                  deptName: val.deptNameIds
                    ? val.deptNameIds.map((val) => val.deptName).join("、")
                    : "-",
                };
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    serveSubjectToString(arr) {
      const newArr = arr.map((val) => val.subjectName);
      return newArr.join("、");
    },
    changeTabIndex(index) {
      this.tabIndex = index;
      this.$nextTick(() => {
        this.fetchList();
      });
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped>
.app-item {
  height: 140px;
}

.app-item:hover {
  background: #edf5fe;
}

.tab-bar {
  height: 46px;
  line-height: 46px;
}

.tab-bar-item.active,
.tab-bar-item:hover {
  background: #519fe8;
  color: #fff;
}
</style>
